<template>
  <div>
    <div class="row mb-3">
      <div class="col-md-6" v-show="isNumerationFile || isExternal">
        <list-subject-types
          class="w-100"
          autocomplete
          label="Destinos"
          name="subjectType"
          data-cy="subject-type"
          v-model="subjectForm.subjectType"
          v-validate="'required'"
          :danger="errors.has(`${scope}.subjectType`)"
          :danger-text="errors.first(`${scope}.subjectType`)"
          ref="subjectType"
        />
      </div>
      <div class="col-md-6" v-show="isNumerationFile || isExternal">
        <list-offices
          v-if="
              !isInput.includes(subjectForm.subjectType)
                && subjectForm.subjectType === 'oficinas'
            "
          class="w-100"
          autocomplete
          label="Oficina"
          name="subject"
          data-cy="subject"
          v-model="subjectForm.subject"
          :danger="errors.has(`${scope}.subject`)"
          :danger-text="errors.first(`${scope}.subject`)"
          v-validate="{ required:  !isInput.includes(subjectForm.subjectType)
                && subjectForm.subjectType === 'oficinas' }"
          ref="subject"
          key="subject-select"
        />
        <list-groups
          v-if="
              !isInput.includes(subjectForm.subjectType)
                && subjectForm.subjectType === 'unidades'
            "
          class="w-100"
          autocomplete
          label="Unidad"
          name="subject"
          data-cy="subject"
          :typeList="1"
          v-model="subjectForm.subject"
          :danger="errors.has(`${scope}.subject`)"
          :danger-text="errors.first(`${scope}.subject`)"
          v-validate="{ required:  !isInput.includes(subjectForm.subjectType)
                && subjectForm.subjectType === 'unidades' }"
          ref="subject"
          key="subject-select"
        />
        <list-subjects
          v-if="
              !isInput.includes(subjectForm.subjectType)
                && subjectForm.subjectType !== 'usuarios'
                && subjectForm.subjectType !== 'oficinas'
                && subjectForm.subjectType !== 'unidades'
                && subjectForm.subjectType !== 'sanitarias'
            "
          class="w-100"
          autocomplete
          label="Lista de Destino"
          name="subject"
          data-cy="subject"
          v-model="subjectForm.subject"
          :parent-value="subjectForm.subjectType"
          v-validate="{
             required: !isInput.includes(subjectForm.subjectType)
                && subjectForm.subjectType !== 'usuarios'
                && subjectForm.subjectType !== 'oficinas'
                && subjectForm.subjectType !== 'unidades'
                && subjectForm.subjectType !== 'sanitarias'
            }"
          :disabled="!subjectForm.subjectType"
          :danger="errors.has(`${scope}.subject`)"
          :danger-text="errors.first(`${scope}.subject`)"
          ref="subject"
          key="subject-select"
        />
        <list-user
          with-filters
          v-if="
              !isInput.includes(subjectForm.subjectType)
                && subjectForm.subjectType === 'usuarios'
            "
          class="w-100"
          withFilters
          rolId="7441a75e-80b9-486a-8595-34c487a56dd9"
          autocomplete
          label="Lista de Destino"
          name="subject"
          data-cy="subject"
          v-model="subjectForm.subject"
          v-validate="{
              required: !isInput.includes(subjectForm.subjectType)
                && subjectForm.subjectType === 'usuarios'
            }"
          :disabled="!subjectForm.subjectType"
          :danger="errors.has(`${scope}.subject`)"
          :danger-text="errors.first(`${scope}.subject`)"
          ref="subject"
          key="subject-select"
        />
        <vs-input
          v-if="isInput.includes(subjectForm.subjectType)"
          class="w-100"
          label="Ingrese un nombre"
          name="subject"
          data-cy="subject"
          v-model="subjectForm.subject"
          v-validate="{ required: isInput.includes(subjectForm.subjectType) }"
          :danger="errors.has(`${scope}.subject`)"
          :danger-text="errors.first(`${scope}.subject`)"
          key="subject-input"
        />
      </div>
    </div>
    <div class="row mb-3" v-if="subjectForm.subjectType === 'docDigital'">
      <div class="col-12">
        <list-institutions-doc-digital
          class="w-100"
          autocomplete
          label="Lista de Instituciones DocDigital"
          name="subjectTypeDigitalDoc"
          data-cy="subject-type-digital-doc"
          v-model="subjectForm.subjectTypeDigitalDoc"
          :parent-value="subjectForm.subject"
          v-validate="{ required: subjectForm.subjectType === 'docDigital'}"
          :danger="errors.has(`${scope}.subjectTypeDigitalDoc`)"
          :danger-text="errors.first(`${scope}.subjectTypeDigitalDoc`)"
          ref="subjectTypeDigitalDoc"
        />
      </div>
      <div
        class="col-3"
        v-if="subjectForm.subjectType === 'docDigital'
        && subjectForm.subject !== ''
        && subjectForm.subject !== undefined"
      >
        <vs-checkbox
          v-model="selectAllDocDigital"
          class="mt-2"
          color="primary"
          v-on:change.native="selectDocDigital()"
          v-tooltip="'Seleccionar todas las instituciones DocDigital'"
          :disabled="disabledSelectAll"
        >
          Seleccionar todas
        </vs-checkbox>
      </div>
    </div>
    <div class="row mb-3" v-if="emailRequired.includes(subjectForm.subjectType)">
      <div class="col-12">
        <vs-input
          class="w-100"
          label="Correo Electrónico Persona Destinatario"
          name="subjectEmail"
          data-cy="subject-email"
          v-model="subjectForm.subjectEmail"
          v-validate="{
              required: emailRequired.includes(subjectForm.subjectType)
              ,
              email: true
            }"
          :danger="errors.has(`${scope}.subjectEmail`)"
          :danger-text="errors.first(`${scope}.subjectEmail`)"
        />
      </div>
    </div>
    <div class="row mb-3" v-if="subjectForm.subjectType === 'usuarios'">
      <div class="col-6">
        <vs-select
          autocomplete
          class="w-100 con-select autocompletex"
          label="Seleccione tipo de providencia"
          v-model="subjectForm.providence"
          name="providence"
          data-cy="providence"
        >
          <vs-select-item
            v-if="!isExternal"
            :value="providenceTypes.KNOWLEDGE"
            text="Conocimiento"
          />
          <vs-select-item
            :value="providenceTypes.MANAGEMENT"
            text="Para gestión"
          />
        </vs-select>
      </div>
      <div class="col-6">
        <label>Fecha Vencimiento</label>
        <b-form-datepicker
          locale="es"
          :min="minDate"
          placeholder="Fecha vencimiento"
          name="providenceExpiration"
          v-model="subjectForm.providenceExpiration"
          label-help="Puede usar las flechas del teclado y espacio"
        />
      </div>
    </div>
    <div class="row mb-3">
      <div class="col-12 d-flex align-items-end justify-content-end">
        <div v-if="error.message !== ''" class="con-text-validation span-text-validation-danger
           vs-input--text-validation-span v-enter-to text-right"
             style="height: 32px;">
          <span class="span-text-validation">
            {{error.message}}
          </span>
        </div>
      </div>
      <div class="col-12 d-flex align-items-end justify-content-end">
        <b-button
          data-cy="add-recipient-button"
          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
          variant="primary"
          v-on:click="addSubject()"
        >
          Agregar Destinatario
        </b-button>
      </div>
    </div>
  </div>
</template>
<script>

import Ripple from 'vue-ripple-directive';
import { mapGetters } from 'vuex';

import ListSubjectTypes from '@/febos/chile/lists/components/ListSubjectTypes';
import ListUser from '@/febos/chile/lists/components/ListUser';
import ProvidencesTypes from '@/febos/chile/dnt/mixins/ProvidencesTypes';
import ListSubjects from '@/febos/chile/lists/components/ListSubjects';
import ListInstitutionsDocDigital from '@/febos/chile/lists/components/ListInstitutionsDocDigital';
import ListOffices from '@/febos/chile/lists/components/ListOffices';
import ListGroups from '@/febos/chile/lists/components/ListGroups';

export default {
  components: {
    ListSubjectTypes,
    ListUser,
    ListSubjects,
    ListInstitutionsDocDigital,
    ListOffices,
    ListGroups
  },
  directives: {
    Ripple,
  },
  props: {
    docTypeSelected: { type: Object, default: () => {} },
    scope: { type: String }
  },
  data() {
    const { wizard } = this.$route.params;
    return {
      error: {
        message: ''
      },
      locale: 'es',
      wizard,
      selectAllSanitaries: false,
      selectAllDocDigital: false,
      labels: {
        es: {
          labelPrevDecade: 'Década anterior',
          labelPrevYear: 'Año anterior',
          labelPrevMonth: 'Mes anterior',
          labelCurrentMonth: 'Mes actual',
          labelNextMonth: 'Mes siguiente',
          labelNextYear: 'Año siguiente',
          labelNextDecade: 'Década siguiente',
          labelToday: 'Hoy',
          labelSelected: 'Fecha seleccionada',
          labelNoDateSelected: 'Sin fecha seleccionada',
          labelCalendar: 'Calendario',
          labelNav: 'Navegación calendario',
          labelHelp: 'Use las teclas del cursor para navegar por las fechas del calendario',
          labelReset: 'Borrar',
          'label-today-button': 'Hoy',
          'label-reset-button': 'Borrar',
          'label-close-button': 'Cerrar'
        }
      },
      minDate: this.$moment().format('YYYY-MM-DD'),
      providenceTypes: ProvidencesTypes,
      emailRequired: ['personas', 'empresas', 'ministerios', 'personasJuridicas', 'organismoEstado'],
      isInput: ['personas', 'empresas', 'personasJuridicas', 'organismoEstado'],
      subjectForm: {
        subjectType: (wizard === 'externo' || wizard === 'ddExterno') ? 'oficinas' : 'usuarios',
        providence: '',
        providenceExpiration: '',
        subject: '',
        subjectTypeDigitalDoc: '',
        subjectEmail: '',
      }
    };
  },
  computed: {
    ...mapGetters('Empresas', ['company']),
    ...mapGetters('List', [
      'sanitaryCompaniesState',
      'docDigitalList'
    ]),
    isNumerationFile() {
      const { wizard } = this.$route.params;
      const route = this.$route.name === 'manage-file-tray';
      return (wizard === 'numOf' || wizard === 'numInt') || route;
    },
    disabledSelectAll() {
      return this.$refs.subjectTypeDigitalDoc.isDisabled;
    },
    isExternal() {
      const { wizard } = this.$route.params;
      const route = this.$route.name === 'manage-file-tray';
      return (wizard === 'externo' || wizard === 'ddExterno') || route;
    },
    isInternal() {
      const { wizard } = this.$route.params;
      const route = this.$route.name === 'manage-file-tray';
      return wizard === 'interno' || route;
    }
  },
  methods: {
    selectSanitaries() {
      if (!this.selectAllSanitaries) {
        this.$emit('clear-sanitaries');
        return;
      }
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Heey!',
        text: 'Estás a punto de seleccionar todas las instituciones sanitarias como'
          + ' destinatarios, esto hará que el expediente a crear sea distribuido a'
          + ' todos los correos de contacto.',
        cancelText: 'Cancelar',
        acceptText: 'Confirmar',
        accept: () => {
          const { list } = this.sanitaryCompaniesState;
          const subjectType = this.$refs.subjectType.getOption();
          list.forEach((subject) => {
            if (subject.extra && subject.extra.correos.length) {
              subject.extra.correos.split(',').forEach((email) => {
                const row = {
                  subjectType,
                  subject,
                  subjectTypeDigitalDoc: {},
                  subjectEmail: email,
                  providence: this.subjectForm.providence,
                  providenceExpiration: this.subjectForm.providenceExpiration,
                  allowMultipleTimes: true
                };
                this.$emit('add-subject', row);
              });
            }
          });
        },
        cancel: () => {
          console.log('no se hizo');
        }
      });
    },
    async validateForm(scope) {
      let result = await this.$validator.validateAll(scope);
      if (this.subjectForm.subjectType === 'docDigital' && (!this.docTypeSelected || !this.docTypeSelected.extra.idDocDigital)) {
        this.error.message = 'El tipo de documento seleccionado no esta configurado para ser enviado a DocDigital';
        result = false;
      }
      return !!result;
    },
    async addSubject() {
      const isValid = await this.validateForm(this.scope);

      if (!isValid) {
        return;
      }

      const subjectType = this.$refs.subjectType.getOption();
      const subject = this.isInput.includes(this.subjectForm.subjectType)
        ? {
          label: this.subjectForm.subject,
          value: this.subjectForm.subject,
          id: this.subjectForm.subject
        }
        : this.$refs.subject.getOption();

      const subjectTypeDigitalDoc = this.$refs.subjectTypeDigitalDoc
        ? this.$refs.subjectTypeDigitalDoc.getOption()
        : {};

      if (this.subjectForm.subjectType === 'sanitarias') {
        if (subject.extra && subject.extra.correos.length) {
          subject.extra.correos.split(',').forEach((email) => {
            const row = {
              subjectType,
              subject,
              subjectTypeDigitalDoc,
              subjectEmail: email,
              providence: this.subjectForm.providence,
              providenceExpiration: this.subjectForm.providenceExpiration,
              allowMultipleTimes: true
            };
            this.$emit('add-subject', row);
          });
        } else {
          this.$bvToast.toast(
            'Esta sanitaria no tiene correo configurado',
            {
              title: '¡Oye!',
              variant: 'warning',
              pauseOnHover: true,
              solid: true,
              noAutoHide: true
            }
          );
        }
      } else {
        const row = {
          subjectType,
          subject,
          subjectTypeDigitalDoc,
          subjectEmail: this.subjectForm.subjectEmail,
          providence: this.subjectForm.providence,
          providenceExpiration: this.subjectForm.providenceExpiration
        };
        this.$emit('add-subject', row);
      }
      this.subjectForm.subject = '';
      this.subjectForm.providenceExpiration = '';
      this.subjectForm.providence = '';
      this.subjectForm.subjectTypeDigitalDoc = '';
      this.subjectForm.subjectEmail = '';
      await this.$validator.reset();
    },
    selectDocDigital() {
      if (!this.selectAllDocDigital) {
        this.$emit('clear-doc-digital');
        return;
      }
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Heey!',
        text: 'Estás a punto de seleccionar todas las instituciones DocDigital como'
          + ' destinatarios, esto hará que el expediente a crear sea distribuido a'
          + ' todos los correos de contacto.',
        cancelText: 'Cancelar',
        acceptText: 'Confirmar',
        accept: async () => {
          const list = this.$refs.subjectTypeDigitalDoc.filteredList;
          const subject = this.isInput.includes(this.subjectForm.subjectType)
            ? {
              label: this.subjectForm.subject,
              value: this.subjectForm.subject,
              id: this.subjectForm.subject
            }
            : this.$refs.subject.getOption();
          const subjectType = this.$refs.subjectType.getOption();
          list.forEach((subjectTypeDigitalDoc) => {
            const row = {
              subjectType,
              subject,
              subjectTypeDigitalDoc,
              subjectEmail: this.subjectForm.subjectEmail,
              providence: this.subjectForm.providence,
              providenceExpiration: this.subjectForm.providenceExpiration,
              allowMultipleTimes: true
            };
            this.$emit('add-subject', row);
          });
          this.selectAllDocDigital = false;
          this.subjectForm.subject = '';
          this.subjectForm.providenceExpiration = '';
          this.subjectForm.providence = '';
          this.subjectForm.subjectTypeDigitalDoc = '';
          this.subjectForm.subjectEmail = '';
          await this.$validator.reset();
        },
        cancel: () => {
          this.selectAllDocDigital = false;
        }
      });
    }
  }
};
</script>
<style>

</style>
